import $ from "jquery";
import cookie from 'jquery.cookie';
import magnificPopup from 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

$(window).on('load', function(){
  let cookie = $.cookie('access');

  if(cookie != 'yes') {
    if($('#js-modalMovie').length){
      $('#js-modalMovie').removeClass('-disable');
      $.magnificPopup.open({
        closeBtnInside: false,
        items: {
          src: '#js-modalMovie',
        },
        showCloseBtn: false,
        type: 'inline',
    //     modal: true,
      }, 0);
      $.cookie('access', 'yes', {expires: 2, path: '/'});
    }
  }
});

$('#js-imodalMovieClose').on('click', () => {
  $('#js-modalMovie').magnificPopup('close');
  $('#js-modalMovieScreen').empty();
});
